
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Actaxiserviceinpune() {



    const cardData =
    {
        keyword: 'AC Taxi Service in Pune',
        heading: 'Platinum24 Cabs: AC Taxi Service in Pune',
        headingDescription: ' Platinum24 Cabs offers reliable AC Taxi Service in Pune, ensuring cool, comfortable, and hassle-free travel for local rides, airport transfers, corporate commutes, and outstation journeys. Our fleet of hatchbacks, sedans, SUVs, and luxury cars is fully air-conditioned and well-maintained to provide maximum comfort even during long trips or peak summers. With professional chauffeurs, punctual service, and transparent fares, we guarantee a stress-free travel experience. Whether you need a daily city ride, a weekend getaway, or an intercity trip, Platinum24 Cabs delivers safe, affordable, and dependable AC taxi services in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732, Shaniwar Wada was the seat of the powerful Peshwas of the Maratha Empire. Its mighty Delhi Gate, ornate fountains, and sprawling courtyards narrate stories of Bajirao and Mastani. Though partially destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show brings Maratha history alive. It attracts history lovers, students, and tourists alike. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, is a national monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now houses a museum displaying Gandhi’s belongings, letters, and photographs. Its sprawling lawns and Italian arches add to the charm. Visitors find both history and peace here. Aga Khan Palace is Pune’s inspiring historic gem."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is remembered for the 1670 battle where Tanaji Malusare fought bravely for Chhatrapati Shivaji Maharaj. Perched on a hilltop, it offers panoramic Sahyadri views and trekking trails. Visitors explore bastions, temples, and memorials tied to Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve traditional pithla-bhakri at the top. Sinhagad is Pune’s perfect mix of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine of Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. Known for its charitable works, it is revered across Maharashtra. Tourists and pilgrims experience its divine aura. Dagdusheth Temple is Pune’s spiritual and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Massive stone pillars, a sanctum, and a Nandi mandapa reflect early Indian craftsmanship. Despite its location in the city center, the site offers peace and spirituality. Evening chants add to the mystical atmosphere. Architecture enthusiasts admire its carvings. Pataleshwar is Pune’s hidden gem of ancient devotion."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and daily-use antiques. The recreated Mastani Mahal is a highlight for visitors. The museum provides a journey through centuries of Indian culture. Students, historians, and art lovers find it fascinating. It is Pune’s proud cultural and heritage treasure."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic city views. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built in the Peshwa era. Visitors climb 103 steps to reach the temple, making it a devotional and adventurous experience. Smaller shrines and a museum enrich its cultural value. Sunrise and sunset views are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a world-renowned wellness center. It offers meditation, yoga, therapy, and personal growth workshops. Spread over lush gardens with Zen-inspired spaces, it attracts visitors from across the globe. The resort blends modern lifestyle with spirituality. It is ideal for peace, rejuvenation, and mindfulness. Osho Ashram is Pune’s international spiritual hub."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns create a serene setting. Families enjoy picnics, photography, and peaceful walks here. Seasonal flowers and greenery make it a year-round delight. The garden symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of beauty and calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, on the Mutha River, is a popular weekend retreat near Pune. It supplies water to the city and offers beautiful views of surrounding hills. In monsoon, the overflowing waters create a spectacular scene. Vendors selling hot corn and tea add to the charm. It is also the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural escape."
  }
],



    "services": [
    {
      "name": "AC Taxi Pune",
      "description": "Experience comfortable and cool rides across Pune with our AC Taxi service. Perfect for beating the heat during summer or maintaining a pleasant environment during your travel, our air-conditioned taxis ensure you arrive refreshed and relaxed. Whether for local trips, airport transfers, or outstation journeys, our AC taxis provide a premium travel experience with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune AC Cab Service",
      "description": "Our Pune AC Cab Service offers reliable, clean, and temperature-controlled rides suitable for all types of travelers. From daily commutes to special occasions, our AC cabs are equipped to make your journey smooth and enjoyable. With flexible booking options and transparent pricing, you can count on us for timely pickups and safe drop-offs."
    },
    {
      "name": "Affordable AC Taxi Pune",
      "description": "Get the best value for money with our Affordable AC Taxi service in Pune. We combine comfort and cost-effectiveness, allowing you to travel in air-conditioned luxury without breaking your budget. Perfect for students, working professionals, and families, our affordable AC taxis offer competitive rates and dependable service."
    },
    {
      "name": "Pune AC Taxi Booking",
      "description": "Booking your AC taxi in Pune is now easier than ever with our seamless online and phone reservation system. Choose your preferred vehicle type, schedule your ride, and receive instant confirmation. Our efficient booking process ensures your AC taxi arrives on time, every time, making your travel hassle-free."
    },
    {
      "name": "AC Taxi with Driver Pune",
      "description": "Travel stress-free with our AC Taxi with Driver service in Pune. Our professional drivers are trained to provide courteous, safe, and punctual service, navigating city traffic and routes efficiently. Enjoy personalized assistance and local knowledge that enhance your travel experience."
    },
    {
      "name": "Pune AC Cab Rental",
      "description": "Rent an AC cab in Pune for hourly or daily use with flexible rental packages. Whether for business meetings, sightseeing tours, or family outings, our AC cab rental service offers comfort and convenience tailored to your itinerary. Benefit from well-maintained vehicles and experienced drivers for a seamless ride."
    },
    {
      "name": "AC Taxi Packages Pune",
      "description": "Choose from our specialized AC Taxi Packages in Pune designed to suit different travel needs such as airport transfers, corporate travel, sightseeing tours, and outstation trips. Our packages offer fixed rates, making budgeting easier while providing the luxury of air-conditioned comfort throughout your journey."
    },
    {
      "name": "Pune AC Taxi Rates",
      "description": "Enjoy transparent and competitive AC taxi rates in Pune with no hidden charges. Our fare structure covers all aspects, including distance, waiting time, tolls, and driver allowances, ensuring you know exactly what you pay for. Get instant fare estimates during booking to plan your travel budget effectively."
    },
    {
      "name": "AC Taxi for Corporate Pune",
      "description": "Our AC Taxi service for corporate clients in Pune offers professional, punctual, and comfortable rides for business travel, client pickups, and employee transportation. Benefit from customized billing, priority service, and dedicated account management designed to meet your corporate needs."
    },
    {
      "name": "AC Taxi Service Near Me Pune",
      "description": "Locate the nearest AC taxi service in Pune easily with our extensive network of drivers and vehicles. Whether you’re at home, office, or on the go, our quick dispatch system ensures an AC taxi is never far away, ready to provide a comfortable ride anytime."
    },
    {
      "name": "24x7 AC Taxi Pune",
      "description": "Avail our 24x7 AC Taxi service in Pune for round-the-clock air-conditioned transportation. Whether you need early morning airport transfers, late-night rides, or day-long trips, our AC taxis are available anytime, ensuring your comfort regardless of the hour."
    },
    {
      "name": "Pune AC Airport Taxi",
      "description": "Make your airport journeys stress-free with our Pune AC Airport Taxi service. Enjoy timely pickups and drop-offs in air-conditioned comfort, helping you avoid the hustle and bustle of travel. Our drivers monitor flight timings to ensure you reach on time, every time."
    },
    {
      "name": "AC Taxi Deals Pune",
      "description": "Take advantage of exclusive AC Taxi deals in Pune offering discounted rates on daily rides, weekend trips, and long-distance travel. Our special promotions and seasonal offers make traveling in air-conditioned taxis even more affordable and accessible."
    },
    {
      "name": "AC Outstation Taxi Pune",
      "description": "Plan your outstation trips from Pune with our reliable AC Outstation Taxi service. Whether it’s a business trip, family vacation, or pilgrimage, travel comfortably with air-conditioned vehicles and experienced drivers who ensure a safe and pleasant journey to your destination."
    },
    {
      "name": "Pune AC Taxi Hire",
      "description": "Hire an AC taxi in Pune for flexible durations ranging from a few hours to multiple days. Ideal for local sightseeing, airport transfers, or corporate events, our AC taxi hire service guarantees comfort, convenience, and personalized service with no compromise on quality."
    }
  ],
  "tableData": [
    ["AC Taxi Pune", "Pune AC Cab Service"],
    ["Affordable AC Taxi Pune", "Pune AC Taxi Booking"],
    ["AC Taxi with Driver Pune", "Pune AC Cab Rental"],
    ["AC Taxi Packages Pune", "Pune AC Taxi Rates"],
    ["AC Taxi for Corporate Pune", "AC Taxi Service Near Me Pune"],
    ["24x7 AC Taxi Pune", "Pune AC Airport Taxi"],
    ["AC Taxi Deals Pune", "AC Outstation Taxi Pune"],
    ["Pune AC Taxi Hire", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Comfortable AC Taxi Service in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable air-conditioned taxi services across Pune for a cool and pleasant ride."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized AC Vehicles",
      "WhyChoosedescription": "Travel in clean, regularly sanitized AC cabs that ensure your comfort and safety."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Expertise",
      "WhyChoosedescription": "Our professional drivers know Pune’s routes well to provide timely and safe journeys."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
      "WhyChoosedescription": "Choose from hourly rentals, one-way trips, or round trips based on your travel needs."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing covering fuel, tolls, and driver allowances for worry-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
      "WhyChoosedescription": "Our dedicated team is available around the clock to assist with bookings and inquiries."
    },
    {
      "WhyChooseheading": "Ideal for Corporate Travel, Airport Transfers, and Personal Use",
      "WhyChoosedescription": "Our AC taxi services cater to various travel requirements in Pune."
    },
    {
      "WhyChooseheading": "Multiple AC Vehicle Options Available",
      "WhyChoosedescription": "Select from sedans, SUVs, and other AC models to suit your comfort and group size."
    }
  ]

































    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer AC taxi services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides comfortable and reliable AC taxi services across Pune for local and outstation travel.',
    },
    {
        question: 'How can I book an AC taxi in Pune with Platinum24 Cabs?',
        answer: 'You can book an AC taxi easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of AC vehicles are available for hire in Pune?',
        answer: 'We offer a range of AC vehicles including sedans, SUVs, and luxury cars to suit your comfort and travel needs.',
    },
    {
        question: 'Are the AC taxi drivers professional and experienced?',
        answer: 'Yes, our drivers are trained, professional, and familiar with Pune city and nearby routes.',
    },
    {
        question: 'Can I hire an AC taxi for hourly, daily, or outstation trips?',
        answer: 'Absolutely, we provide flexible rental packages for AC taxis including hourly, daily, and multi-day options.',
    },
    {
        question: 'Are AC taxis sanitized and safe for passengers?',
        answer: 'Yes, all our AC vehicles are regularly sanitized and maintained with strict hygiene and safety protocols.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for AC taxi rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points anywhere within Pune or for outstation travel.',
    },
    {
        question: 'What payment methods are accepted for AC taxi services?',
        answer: 'We accept cash, credit/debit cards, and digital wallets for convenient payments.',
    },
    {
        question: 'Is 24x7 AC taxi service available in Pune?',
        answer: 'Yes, our AC taxi services are available round the clock to meet your travel requirements.',
    },
    {
        question: 'Do you offer corporate AC taxi services in Pune?',
        answer: 'Yes, we offer tailored corporate AC taxi solutions with priority support and flexible billing options.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rahul Patil',
        feedback: 'The AC taxi service from Platinum24 Cabs was excellent — comfortable vehicle and punctual driver.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Snehal Deshmukh',
        feedback: 'Booked an AC taxi for my Pune travel, and the experience was top-notch with a clean car and friendly driver.',
        rating: 5,
    },
];

























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const acTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable AC taxi service in Pune offering AC cabs with driver, corporate packages, airport transfers, and 24x7 AC taxi hire.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "AC Taxi Pune",
    "Pune AC Cab Service",
    "Affordable AC Taxi Pune",
    "Pune AC Taxi Booking",
    "AC Taxi with Driver Pune",
    "Pune AC Cab Rental",
    "AC Taxi Packages Pune",
    "Pune AC Taxi Rates",
    "AC Taxi for Corporate Pune",
    "AC Taxi Service Near Me Pune",
    "24x7 AC Taxi Pune",
    "Pune AC Airport Taxi",
    "AC Taxi Deals Pune",
    "AC Outstation Taxi Pune",
    "Pune AC Taxi Hire"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>
<Helmet>
  <title>AC Taxi Service in Pune | Affordable & Reliable AC Cabs</title>
  <meta
    name="description"
    content="Affordable and reliable AC taxi service in Pune offering AC cabs with driver, corporate packages, airport transfers, and 24x7 AC taxi hire."
  />
  <meta
    name="keywords"
    content="AC Taxi Pune, Pune AC Cab Service, Affordable AC Taxi Pune, Pune AC Taxi Booking, AC Taxi with Driver Pune, Pune AC Cab Rental, AC Taxi Packages Pune, Pune AC Taxi Rates, AC Taxi for Corporate Pune, AC Taxi Service Near Me Pune, 24x7 AC Taxi Pune, Pune AC Airport Taxi, AC Taxi Deals Pune, AC Outstation Taxi Pune, Pune AC Taxi Hire"
  />
  <script type="application/ld+json">
    {JSON.stringify(acTaxiSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/64.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Actaxiserviceinpune;